import { ACTION_TYPES } from "reducers/actionTypes";
import api from "ApiClient";

export const getFields = url => {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.fields.loading
    });
    return api
      .get(url)
      .then(response => {
        dispatch({
          type: ACTION_TYPES.fields.success,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: ACTION_TYPES.fields.failure,
          payload: error
        });
      });
  };
};
